var render, staticRenderFns
import script from "./copyASummary.vue?vue&type=script&lang=js&"
export * from "./copyASummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6088f5e",
  null
  
)

export default component.exports